import {mapGetters} from 'vuex'

export default {
	computed: {
		...mapGetters(['read']),
		theme() {
			let theme = this.read('theme')
      return {
        primary: theme.PrimaryColor,
        secondary: theme.SecondaryColor
      }
		},
    styles() {
      return {
        primary: {
          background: `background:${this.theme.primary}`,
          color: `color:${this.theme.primary}`
        },
        secondary: {
          background: `background:${this.theme.secondary}`,
          color: `color:${this.theme.secondary}`
        }
      }
    }
	}
}